import { Button } from "@/components/ui/button"
import { useTranslation } from "@/hooks/useTranslation/useTranslation"
import { cn } from "@/lib/utils"
import { IconLoader2 } from "@tabler/icons-react"
import { Trash2 } from "lucide-react"

interface DeleteIconButtonProps {
  onClick: (e: React.MouseEvent) => void
  loading?: boolean
  label?: string
  className?: string
}

/**
 * Small icon button used to remove an item. Shows a spinner while `loading`.
 * Rendered absolute by default — wrap the parent with `relative` and pass
 * positioning classes via `className`.
 */
export function DeleteIconButton({
  onClick,
  loading = false,
  label,
  className,
}: DeleteIconButtonProps) {
  const { translate } = useTranslation()

  return (
    <Button
      type="button"
      variant="outline"
      size="icon"
      aria-label={label ?? translate("MC_MD_DELETE_BTN_LABEL")}
      disabled={loading}
      onClick={onClick}
      className={cn(
        "absolute h-6 w-6 rounded-full border-border bg-card text-muted-foreground",
        "hover:border-destructive hover:text-destructive",
        className,
      )}
    >
      {loading ? (
        <IconLoader2 className="h-1 w-1 animate-spin" />
      ) : (
        <Trash2 className="h-0.5 w-0.5" />
      )}
    </Button>
  )
}
